/**
 * Header icon + logo
 */
import config from 'config';
import { INDEX } from 'config/fe-routes';
import Router, { useRouter } from 'next/router';
import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { setGlobalLoader } from 'store/actions/global-loader.actions';
import { StoreData } from 'store/root-reducer';
import { GTM, GTMButtons } from 'utils/analytics';
import { redirectTo } from 'utils/route-helpers';

import { useLanguage } from '../../../../hooks/useLanguage';
import { getPreviousHistoryTrackerRoute } from '../../../../utils/route-history-tracker';
import { HeaderIconLogo } from './HeaderIconLogo';

type Props = {
  icon?: ReactNode | 'home' | 'back';
  // If "iconOnClick" returns true, default functionality will be called after calling "iconOnClick"
  iconOnClick?: (history: Array<string>) => boolean;
  showLogo?: boolean;
  price?: string | JSX.Element;
  children?: ReactNode;
  className?: string;
  history?: Array<string>;
  hasPrice?: boolean;
};

const isDevelopment = ['dev', 'local'].includes(config.get('env'));

const HeaderIconLogoContainer = (props: Props) => {
  const history = useSelector(({ historyData }: StoreData) => historyData.history);
  const { availableLanguages } = useLanguage();

  const { asPath: currentPath } = useRouter();

  const goBack = () => {
    const previousPath = getPreviousHistoryTrackerRoute(history)?.as;

    setGlobalLoader(true, undefined, 'with-delay');

    GTM.buttonClicked(GTMButtons.BACK_BUTTON);

    if (!previousPath || previousPath === currentPath) {
      redirectTo(INDEX());

      return;
    }

    // Otherwise go back in history
    Router.back();
  };

  const headerIconLogoProps = {
    ...props,
    history,
    isDevelopment,
    languagesList: availableLanguages,
    goBack,
  };

  return <HeaderIconLogo {...headerIconLogoProps} />;
};

export default HeaderIconLogoContainer;
